exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ncanvas[data-v-4352fa5d] {\n  background: transparent;\n  display: block;\n  margin: auto;\n  max-height: 100%;\n  max-width: 100%;\n}\n", ""]);

// exports
